import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-IPRestriction',
    templateUrl: './IPRestriction.component.html'
})
export class IPRestrictionComponent implements OnInit {

    consumerID: string;
    whitelist: [];
    blacklist: [];

    data = {
        'consumerID' : this.consumerID,
        'whitelist' : this.whitelist,
        'blacklist' : this.blacklist,
        'plugin' : 'ip-restriction'
    }

    constructor() { }

    IPRestriction() {
    }
    ngOnInit() {
    }

}
